// web-shop's LoggedInGuard is the only thing on the store and auth routes that answers 403, and it
// answers with Nest's JSON error body. A 403 that is not JSON came from in front of web-shop:
// Cloudflare's WAF serves an HTML block page, and its browser check a plain-text "error code: 1010".
// The session may be fine then, so it must not log the player out, and it keeps reporting like any
// other failed request. Kept dependency-free so it runs under `node --test`.
export const isSessionExpired = (response) =>
    response.status === 403 && (response.headers.get('content-type') || '').includes('application/json');
